__turbopack_context__.v({
  "dots": "tech-slider-module__diaJDa__dots",
  "glowBlob": "tech-slider-module__diaJDa__glowBlob",
  "glowBlobBottomCenter": "tech-slider-module__diaJDa__glowBlobBottomCenter",
  "glowBlobBottomRight": "tech-slider-module__diaJDa__glowBlobBottomRight",
  "glowBlobMobileTopLeft": "tech-slider-module__diaJDa__glowBlobMobileTopLeft",
  "glowBlobTopLeft": "tech-slider-module__diaJDa__glowBlobTopLeft",
  "textGlow": "tech-slider-module__diaJDa__textGlow",
  "textGlowStrong": "tech-slider-module__diaJDa__textGlowStrong",
});
